export const ARTICLE_ENREGISTRER = 'article/ARTICLE_ENREGISTRER';
export const ARTICLE_LISTER = 'article/ARTICLE_LISTER';
export const ARTICLE_RECHERCHER = 'article/ARTICLE_RECHERCHER';
export const ARTICLE_SUPPRIMER = 'article/ARTICLE_SUPPRIMER';
export const ARTICLE_LIRE = 'article/ARTICLE_LIRE';

export const defaultFiltre = {};
